import React, { createContext, useContext, useState, useEffect } from 'react';

const SubscriptionContext = createContext();

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscription must be used within SubscriptionProvider');
  }
  return context;
};

export const SubscriptionProvider = ({ children }) => {
  const [subscriptions, setSubscriptions] = useState(() => {
    const saved = localStorage.getItem('liberado_subscriptions');
    return saved ? JSON.parse(saved) : {};
  });

  useEffect(() => {
    localStorage.setItem('liberado_subscriptions', JSON.stringify(subscriptions));
  }, [subscriptions]);

  const getSubscription = (userId) => {
    return subscriptions[userId] || {
      plan: 'standard',
      postsUsed: 0,
      postsLimit: 5,
      startDate: new Date().toISOString(),
      nextReset: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
    };
  };

  const updateSubscription = (userId, updates) => {
    setSubscriptions(prev => ({
      ...prev,
      [userId]: {
        ...prev[userId],
        ...updates,
      },
    }));
  };

  const incrementPostUsage = (userId) => {
    const sub = getSubscription(userId);
    updateSubscription(userId, {
      postsUsed: sub.postsUsed + 1,
    });
  };

  const changePlan = (userId, newPlan) => {
    const limits = {
      standard: 5,
      pro: 15,
      enterprise: 999999,
    };
    updateSubscription(userId, {
      plan: newPlan,
      postsLimit: limits[newPlan] || 5,
    });
  };

  const resetPostUsage = (userId) => {
    updateSubscription(userId, { postsUsed: 0 });
  };

  return (
    <SubscriptionContext.Provider value={{
      subscriptions,
      getSubscription,
      updateSubscription,
      incrementPostUsage,
      changePlan,
      resetPostUsage,
    }}>
      {children}
    </SubscriptionContext.Provider>
  );
};
